import {ChangeDetectionStrategy, Component, EventEmitter, Output, TemplateRef, ViewChild} from '@angular/core';

@Component({
  selector: 'mtg-typeahead',
  templateUrl: './typeahead.component.html',
  exportAs: 'mtgTypeahead',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypeaheadComponent {
  @ViewChild(TemplateRef)
  template: TemplateRef<HTMLElement>;

  @Output()
  change = new EventEmitter();

  isVisible: boolean;

  selectedItem(value: any) {
    this.change.emit(value);
  }
}
